/***
 * 存储缓存内容
 * @param key
 * @param val
 */
function setStorage (key, val) {
  if (key === undefined || val === undefined) return
  window.localStorage.setItem(key, (
    typeof val === 'object'
  ) ? JSON.stringify(val) : val)
}

/***
 * 获取指定缓存内容
 * @param key
 * @param noParse
 * @returns {string}
 */
function getStorage (key, noParse = false) {
  if (key === undefined) return ''
  let val
  try {
    if (noParse) {
      val = window.localStorage.getItem(key)
    } else {
      val = JSON.parse(window.localStorage.getItem(key))
    }
  } catch (e) {
    val = window.localStorage.getItem(key)
  }
  return val
}

/***
 * 删除指定缓存内容
 * @param key
 * @returns {string}
 */
function clearStorageItem (key) {
  window.localStorage.removeItem(key)
}

export {
  setStorage,
  getStorage,
  clearStorageItem
}



// WEBPACK FOOTER //
// ./src/utils/stroage/stroage.js